import { Link } from "react-router-dom";

export default function RelatedPost({ relatedPost }) {
  const { id, title, image, tags, createdAt } = relatedPost;
  return (
    <div className="card">
      <Link to={`/posts/${id}`}>
        <img src={image} className="card-image" alt="" />
      </Link>
      <div className="p-4">
        <Link
          to={`/posts/${id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {title}
        </Link>
        <div className="mb-0 tags">
          {tags.map((tag) => (
            <>
              <span key={tag}>#{tag},</span>{" "}
            </>
          ))}
        </div>
        <p>{createdAt}</p>
      </div>
    </div>
  );
}
